// @flow

import _ from 'lodash';

import { DENTAL } from 'client/constants/dental/tracking';
import {
  HEALTH,
  HIOS_ID,
  PLAN_YEAR,
  STRIDE_PLAN_ID,
  SUBSIDY_AMOUNT,
} from 'client/constants/health/tracking';
import { titleCase } from 'client/utils/format';
import { VISION } from 'client/constants/vision/tracking';
import CORE_PRODUCT_TYPES from 'client/constants/productTypes';

import { ACTION, CART_ACTION, CART_VIEW, TOTAL_CART_VALUE } from 'routes/cart/constants/tracking';
import { getAppByType, getPremiumTotal } from 'routes/cart/util';

import { Tracking } from 'web-core/src/tracking';

import type { AppType, IfpAppType } from 'web-core/types/ifp-app';

const getAppPremiumParams = (app: IfpAppType) => ({
  [`${titleCase(app.type)} Premium`]: _.get(app, 'premium', null),
});

const getHealthAppParams = (healthApp: IfpAppType) => ({
  [PLAN_YEAR]: _.get(healthApp, 'app_json.plan.planYear'),
  ...getAppPremiumParams(healthApp),
  [SUBSIDY_AMOUNT]: _.get(healthApp, 'app_json.plan.mods.savings.subsidy', 0),
  [STRIDE_PLAN_ID]: _.get(healthApp, 'app_json.plan.id'),
  [HIOS_ID]: _.get(healthApp, 'app_json.plan.planId'),
});

export const getCartTrackingDetails = (apps: Array<IfpAppType>) => {
  const healthApp = getAppByType(apps, CORE_PRODUCT_TYPES.HEALTH);
  const dentalApp = getAppByType(apps, CORE_PRODUCT_TYPES.DENTAL);
  const visionApp = getAppByType(apps, CORE_PRODUCT_TYPES.VISION);

  return {
    [HEALTH]: !!healthApp,
    [DENTAL]: !!dentalApp,
    [VISION]: !!visionApp,
    [TOTAL_CART_VALUE]: getPremiumTotal(apps),
    ...(healthApp ? getHealthAppParams(healthApp) : {}),
    ...(dentalApp ? getAppPremiumParams(dentalApp) : {}),
    ...(visionApp ? getAppPremiumParams(visionApp) : {}),
  };
};

export const trackCartView = (apps: Array<IfpAppType>) => {
  if (!_.isEmpty(apps)) {
    const cartDetails = getCartTrackingDetails(apps);
    return Tracking.track(CART_VIEW, cartDetails);
  }
  return null;
};

export const getEditPlanTrackingParams = (type: AppType) => ({
  [ACTION]: `Edit ${titleCase(type)} Plan`,
});

export const getRemovePlanTrackingParams = (type: AppType) => ({
  [ACTION]: `Remove ${titleCase(type)} Plan`,
});

export const trackRemovePlanFromCart = (type: AppType) =>
  Tracking.track(CART_ACTION, getRemovePlanTrackingParams(type));

export const trackChangePlanInCart = (type: AppType) =>
  Tracking.track(CART_ACTION, getEditPlanTrackingParams(type));
